import { useLocation } from 'react-router-dom'
import { matchPath } from 'react-router'

export function useDefineCurrentPathName(pathNameTemplate: string) {
  const { pathname } = useLocation()

  return matchPath(pathNameTemplate, pathname)
}
